import React, { useState, useEffect, useContext } from "react";
import { Container, Col, Row, Card, Form, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import AllHeader from "../../components/AllHeader";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import BigLoader from "../../components/BigLoader";
import { toast } from "react-toastify";
import useCheckUser from "../../custom-hooks/useCheckUser";
import axiosInstance from "../../api/axiosInstance";
import MunicipalityDataContext from "../../helpers/MunicipalityDataContext";

function EblaghElectronici() {
  const [category, setCategory] = useState(0);
  const [categoryText, setCategoryText] = useState("");
  const [load, setLoad] = useState("");
  const [eblaghList, setEblaghList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const UserID = localStorage.getItem("UserId");
  const IsUserConfirmed = localStorage.getItem("IsUserConfirmed");
  const municipalitiyData = useContext(MunicipalityDataContext);

  useCheckUser(UserID); //بود به صفحه لاگین برگرده UserId === null هوک برای چک کردن اینکه اگه

  useEffect(() => {
    // if (IsUserConfirmed === "true") {
      if (UserID !== null) {
        setLoad(true);
        axiosInstance
          .post("GetMade100", {
            RecordType: category,
          })
          .then((res) => {
            setLoad(false);
            if (res.data.result === "true") {
              setEblaghList(res.data.data);
              setFileList(res.data.files);
            } else {
              toast.error(res.data.message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
              });
            }
          });
      // }
    } 
  }, [category]);

  const handleChangeCategory = (e) => {
    setCategory(e.target.value);
    setCategoryText(e.target.options[e.target.selectedIndex].text);
  };

  const panjereVahedHandler = () => {
    // برای ورود به سامانه پنجره واحد خدمات دولت ایتدا باید از برنامه خارج شویم بعد وارد این سامانه شویم
    localStorage.removeItem('UserId');
    localStorage.clear();
    localStorage.setItem("isLoggedOut", "true"); // تنظیم فلگ خروج
    switch (municipalitiyData?.name) {
      case 'آمل':
        window.location.assign("https://api.myamol.ir/api/WebApi/LoginToGOV")
        //window.location.replace(url) →  صفحه فعلی رو جایگزین می‌کنه و توی هیستوری نمیمونه
        // window.location.assign(url) → صفحه جدید رو باز می‌کنه و صفحه قبلی تو هیستوری می‌مونه (یعنی بک کار می‌کنه).
       // استفاده میکنیمassign چون اینجا ما نیاز به صفحه قبلی یعنی لاگین داریم پس از 
        break;
      case 'رویان':
        break;
      case 'محمودآباد':
        break;
      default:
        break;
    }  
  }

  return (
    <div className="rgc-pages">
      <AllHeader>
        <span>ابلاغ الکترونیکی</span>
      </AllHeader>
      {/*true برابر  IsUserConfirmed اگه
      false باشه یعنی از طریق پنجره خدمات دولت وارد شده و تایید شده و کاربر میتونه اطلاعات ابلاغیه رو مشاهده کنه و اگه         
       باشه یعنی کاربر ابتدا باید از طریق پنجره خدمات دولت وارد شده و  اطلاعات حسابش و کدملی تایید بشه و بعد این اجازه
       رو داره تا ابلاغ الکترونیک رو مشاهده کنه */}
      
        <Container>
          <Card className="rgc-card-form p-2 p-md-5">
          {IsUserConfirmed === "true" ? (
            <Row className="justify-content-center justify-content-md-start gy-4">
              <Col xs={12} md={3}>
                <Form.Group controlId="formBasicSelect">
                  {/* <Form.Label>دسته:</Form.Label> */}
                  <Form.Control
                    as="select"
                    browser-default
                    custom-select
                    className="rgc-drop-control"
                    value={category}
                    onChange={(e) => handleChangeCategory(e)}
                  >
                    {" "}
                    <option value="0">نمایش همه</option>
                    <option value="1">اخطار</option>
                    <option value="2">ابلاغ</option>
                    <option value="3">استحکام بنا</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col xs={12}>
                <Table className="table-custom">
                  <Thead>
                    <Tr>
                      <Th>نوع</Th>
                      <Th>وضعیت</Th>
                      <Th>کدنوسازی</Th>
                      <Th>تاریخ</Th>
                      <Th>پیوست ها</Th>
                      <Th>مشاهده</Th>
                      <Th>ثبت دفاعیات/اعتراضات</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {eblaghList.map((data, index) => {
                      const filesList = fileList.filter(
                        (item) => item.recordId === data.Id
                      );
                      return (
                        <Tr
                          key={index}
                          class={data.type === "eblagh" ? "bg-eblagh" : ""}
                        >
                          <Td>
                            {" "}
                            {(() => {
                              switch (data.RecordType) {
                                case 1:
                                  return "اخطار";
                                case 2:
                                  return "ابلاغ";
                                case 3:
                                  return "استحکام بنا";
                                default:
                                  return "ابلاغ";
                              }
                            })()}
                          </Td>
                          <Td>
                            {(() => {
                              switch (data.RecordStatus) {
                                case 1:
                                  return "در انتظار";
                                case 2:
                                  return "دیده شده";
                                case 3:
                                  return "درخواست دفاعیه";
                                case 4:
                                  return "دارای اعتراض";
                                case 5:
                                  return "درخواست ادامه";
                                case 6:
                                  return "مراجعه شده";
                                case 20:
                                  return "اتمام یافته";
                                default:
                                  return "در انتظار";
                              }
                            })()}
                          </Td>
                          <Td>{data.Nosazi}</Td>
                          <Td>{data.Tarikh}</Td>
                          <Td>
                            {filesList.length > 0 && (
                              <NavLink
                                to={`/viewfile/${data.Id}`}
                                state={{
                                  filesList: filesList,
                                }}
                              >
                                <i className="fa fa-file text-info"></i>
                              </NavLink>
                            )}
                          </Td>
                          <Td>
                            <NavLink to={`/moshahedename/${data.Id}`}>
                              <i className="far fa-file-alt text-orange"></i>
                            </NavLink>
                          </Td>
                          <Td>
                            {/* یعنی اگه درخواست دفاعیه یا دارای اعتراض یا درخواست
                          ادامه داشتی آیکون دفاع یا اعتراض در لیست نمایش نده */}
                            <NavLink
                              to={
                                data.RecordStatus !== 3 &&
                                data.RecordStatus !== 5 &&
                                data.RecordStatus !== 4
                                  ? `/sabtdarkhast/${data.Id}`
                                  : "#"
                              }
                              state={{
                                RecordType: data.RecordType,
                                RecordStatus: data.RecordStatus,
                              }}
                              className={
                                data.RecordStatus !== 3 &&
                                data.RecordStatus !== 5 &&
                                data.RecordStatus !== 4
                                  ? "nav-link-active"
                                  : "nav-link-disabled"
                              }
                            >
                              {data.RecordStatus === 5 ||
                              data.RecordStatus === 6 ||
                              data.RecordStatus === 20
                                ? ""
                                : data.RecordType === 1
                                ? "ثبت دفاعیه"
                                : data.RecordType === 2
                                ? "ثبت اعتراض"
                                : ""}
                            </NavLink>
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </Col>
            </Row>
                  )
                  :
                  (<div className="rgc-message bg-light p-3 rounded-4 text-center">
                    <p className="mb-0">برای مشاهده رای ابلاغ و اخطار ماده صد، ابتدا از پنجره واحد خدمات دولت وارد شوید</p>
                    <Button
                      type="submit"
                      className="btn-fill my-2 rgc-btn-login  rgc-btn-NavyBlue col-12 col-md-3 m-auto"
                      onClick={panjereVahedHandler}
                      variant="btn"
                    >
                      <span>ورود از پنجره واحد خدمات وزارت کشور</span>
                    </Button>
                  </div>
                )}
          </Card>

            <Row>
              <Col xs={2} className="rgc-search-position text-center">
               <NavLink to='/made100messages'>
                <Button className="btn rgc-search-btn">
                  <i class='far fa-comment-alt'></i>
                  <span>ارسال پیام</span>
                </Button>
                </NavLink>
              </Col>
            </Row>
        </Container>

      <BigLoader loading={load} />
    </div>
  );
}

export default EblaghElectronici;
